export default "__VITE_ASSET__CU39Y6Py__$_?nuxt_component=async&nuxt_component_name=SvgoBull&nuxt_component_export=default__"